import React from "react";
import CompactNumberInput from "./CompactNumberInput";

export default function BpmInput(props) {
  return <CompactNumberInput {...props} min={0} max={999} clampToBounds />;
}
